// extracted by mini-css-extract-plugin
export var sideRail = "JIvIL";
export var sideRailContainer = "ioy4Y";
export var sideRailContainerBleedThrough = "oSOYZ";
export var sideRailContainerBleedThroughRtl = "ZAM2L";
export var sideRailContainerRtl = "W9jjW";
export var sideRailItemList = "CmiiE";
export var sideRailNodeWrapper = "datbR";
export var slideIn = "bLegw";